import { defaultPieChartOptions, defaultPayoutOptions } from './shared';
import { Consumer } from '@/context/HighChartsProvider';

export default function PieChartProxyHOC(WrappedChartComponent) {
  const WrappedChart = WrappedChartComponent;
  let chartName = '';

  const PieChartProxy = (props) => (
    <Consumer>
      {(value) => {
        if (!value) return;
        const { highCharts } = value;
        const newProps = {
          options: {},
        };
        /** what is this sorcery?!? */
        if (typeof WrappedChart.chartName === 'function')
          chartName = WrappedChart.chartName();
        switch (chartName) {
          case 'DebtLevelChart':
            newProps.options = defaultPayoutOptions(highCharts);
            break;
          default:
            newProps.options = defaultPieChartOptions(highCharts);
        }
        return <WrappedChart {...newProps} {...props} />;
      }}
    </Consumer>
  );

  return PieChartProxy;
}
